module.exports = __webpack_public_path__ + "static/work5-780a3db348bb132c0e85744d4a213d84.jpg";